interface Props {
  page: number;
  totalPages: number;
  total: number;
  onChange: (next: number) => void;
}

function buildPages(page: number, totalPages: number): number[] {
  const pages: number[] = [];
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let index = start; index <= end; index += 1) pages.push(index);
  return pages;
}

export default function Pagination({ page, totalPages, total, onChange }: Props) {
  const pages = buildPages(page, totalPages);

  return (
    <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 sm:flex-row">
      <p className="text-xs text-foreground-600">
        共 <span className="font-medium text-foreground-900">{total}</span> 部作品 · 第 {page} / {totalPages} 页
      </p>
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
          className="flex h-8 cursor-pointer items-center gap-1 rounded border border-background-300 px-2.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
        >
          <i className="ri-arrow-left-s-line text-sm" aria-hidden="true"></i>
          上一页
        </button>
        {pages.map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`h-8 w-8 cursor-pointer rounded text-xs transition-colors ${
              item === page
                ? "bg-primary-600 font-medium text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {item}
          </button>
        ))}
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => onChange(page + 1)}
          className="flex h-8 cursor-pointer items-center gap-1 rounded border border-background-300 px-2.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
        >
          下一页
          <i className="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
}